import React from 'react';
import CargomaticModal from 'components/v2/modal';
import CustomersAPIUtils from 'utils/CustomersAPIUtils';
import { useTranslation } from 'react-i18next';

const InviteConsigneeModal = ({ consignee, onHideModal }) => {
  const { t } = useTranslation();
  const inviteConsignee = async () => {
    await CustomersAPIUtils.inviteConsignee(consignee);
    onHideModal();
  };
  const renderBody = () => {
    return (
      <div className="block">
        <div className="text-lg">
          {t('INVITE_CONFIRMATION')}
          <span className="font-semibold"> {consignee?.first_name}</span> ?
        </div>
        <div className="pt-3">
          {t('EMAIL_SENT_TO')}
          <span className="font-semibold"> {consignee?.email} </span>!
        </div>
      </div>
    );
  };
  const renderFooter = () => {
    return (
      <div className="flex items-center justify-end">
        <button className="button button-secondary pr-3" onClick={onHideModal}>
          {t('CANCEL')}
        </button>
        <button className="button button-green" onClick={inviteConsignee}>
          {t('INVITE')}
        </button>
      </div>
    );
  };
  return (
    <CargomaticModal
      backdrop="static"
      onHide={onHideModal}
      body={renderBody()}
      footer={renderFooter()}
      title={t('INVITE_CONSIGNEE')}
      style={{ top: '30%' }}
    />
  );
};

export default InviteConsigneeModal;
